import { Component, inject, OnInit } from '@angular/core';
import { StreamreportService } from '../../../service/streamreport.service';
import { GenericStreamsService } from '../../../service/generic-streams.service';

@Component({
    selector: 'app-stream-summary',
    standalone: false,
    templateUrl: './stream-summary.component.html',
    styleUrl: './stream-summary.component.scss'
})
export class StreamSummaryComponent implements OnInit {
    reportService = inject(StreamreportService);
    genService = inject(GenericStreamsService)
    report: any[] = [];
    async ngOnInit(): Promise<void> {
        const reportResult = await this.reportService.getStreamSummary();

        // Handle the report data here
        if (reportResult !== false) {
            this.report = reportResult;
        }
    }

    async getCsv(): Promise<void> {
        const csvData = this.createCsvData();
        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'stream_summary.csv';
        a.click();
    }

    createCsvData(): string {
        let data = `"email"; "name"; "company"; "account-created";"last-login"; "stream"; "stream-created-date";"stream-finished-date";\n`
        for (const rep of this.report) {
            if (rep.streams.length > 0) {
                for (const stream of rep.streams) {
                    const c = this.genService.allStreams.find(s => s.id === stream.configId);
                    data += `"${rep.email}"; "${rep.prename} ${rep.lastname}"; "${rep.companyName}"; "${new Date(rep.created).toLocaleString()}"; "${new Date(rep.lastLogin).toLocaleString()}"; "${c?.name || stream.name}"; "${new Date(stream.dateCreate).toLocaleString()}"; "${stream.dateUpdate ? new Date(stream.dateUpdate).toLocaleString() : ""}";\n`
                }
            } else {
                data += `"${rep.email}"; "${rep.prename} ${rep.lastname}"; "${rep.companyName}"; "${rep.accountCreated}"; "${rep.lastLogin}"; ""; ""; "";\n`
            }
        }
        return data;
    }
}
